export default __webpack_public_path__ + "static/media/card-vod-icon.ee53ac56.svg";